import { Component, ElementRef, EventEmitter, Input, Optional, Output, Self, ViewChild } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { format, isValid, parse, subYears } from 'date-fns';
import { LocalizationService } from '@app/services/localization.service';
import { TranslateService } from '@services/translate.service';

@Component({
  selector: 'inputBase',
  template: `
    <div [class]="mainClass + ' ' + extraClass + ' ' + fInputType">
      <label [for]="fID" class="label-b3">{{ fPlaceholder }}</label>

      <div [class]="'input-container ' + fInputType">
        <input
          *ngIf="fInputType !== 'checkbox'"
          [class]="'formType_' + fInputType"
          [type]="fInputType === 'password' ? (showPassword ? 'text' : 'password') : fInputType"
          [min]="fMinVal"
          [max]="fMaxVal"
          [id]="fID"
          [name]="fID"
          [required]="isRequired"
          [(ngModel)]="formValue"
          (keyup)="informChange($event)"
          (change)="informChange($event)"
          (ngModelChange)="handleChange($event)"
          [autocomplete]="fAutoComplete"
          (click)="onTouched()"
          [disabled]="disabled"
          [placeholder]="placeholder" />

        <input
          *ngIf="fInputType === 'checkbox'"
          [class]="'formType_' + fInputType"
          [type]="fInputType"
          [id]="fID"
          [name]="fID"
          (change)="handleChange($event.target.checked)"
          [required]="isRequired"
          [ngModel]="formValue"
          [disabled]="disabled" />
        <div *ngIf="fInputType === 'password'" class="show-hide d-flex" (click)="toogleShowPassword()">
          <image-loader-utils [url]="showPassword ? 'eye-visible' : 'eye-hidden'" extraClasses="m-auto input-icon"></image-loader-utils>
        </div>
        <div *ngIf="fSuffixText !== ''" class="show-hide d-flex">
          <p>{{ fSuffixText }}</p>
        </div>
      </div>
      <div class="error-b3" *ngIf="showError">
        {{ fErrorText }}
      </div>
    </div>
  `,
})
export class InputB3 implements ControlValueAccessor {
  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: any;

  touched = false;

  private errorMessages = new Map<string, () => string>();
  mainClass = 'form-b3 form-field-b3';

  @Input()
  extraClass = '';
  @Input()
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  upperCase = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType: 'text' | 'password' | 'number' | 'checkbox' | 'hidden' = 'text';
  @Input()
  fAutoComplete = 'off';
  @Input()
  fSuffixText = '';

  @Input()
  fMinVal: string;
  @Input()
  fMaxVal: string;
  @Input()
  placeholder = '';

  @Output() informChangeEvent: EventEmitter<any> = new EventEmitter<any>();

  showPassword = false;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  informChange(event) {
    this.informChangeEvent.emit(event);
  }
  handleChange(change: any) {
    this.onTouched();
    if (typeof change === 'boolean') {
      this.formValue = change;
      this.onChanged(change);
      return;
    }
    const newVal = change
      .split('.')
      .map((item, index) => (index === 1 ? `.${item.slice(0, 2)}` : item))
      .join('');

    if (this.fInputType === 'text') {
      const fMin = parseInt(this.fMinVal);
      const fMax = parseInt(this.fMaxVal);
      const changeVal = parseInt(change);

      this.onChanged(newVal);
      if (fMin || fMax) {
        if (fMin && fMin >= changeVal) {
          this.formValue = fMin;
        }

        if (fMax && fMax < changeVal) {
          this.formValue = fMax;
        }
      }
      if (this.upperCase && typeof this.formValue === 'string' && this.formValue.length > 0) {
        this.formValue = this.formValue.charAt(0).toUpperCase() + this.formValue.slice(1);
      }
      this.onChanged(this.formValue);
    } else {
      this.onChanged(change);
    }
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }

  toogleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }
}
@Component({
  selector: 'inputBase-decimal',
  template: `
    <div [class]="mainClass + ' ' + extraClass + ' ' + fInputType">
      <label [for]="fID" class="label-b3">{{ fPlaceholder }}</label>

      <div [class]="'input-container ' + fInputType">
        <input
          *ngIf="fInputType === 'text'"
          [class]="'formType_' + fInputType"
          [type]="fInputType === 'password' ? (showPassword ? 'text' : 'password') : fInputType"
          [min]="fMinVal"
          [max]="fMaxVal"
          [id]="fID"
          [name]="fID"
          [required]="isRequired"
          [(ngModel)]="formValue"
          (change)="informChange($event)"
          (keyup)="handleChange($event)"
          [autocomplete]="fAutoComplete"
          (click)="onTouched()"
          [disabled]="disabled"
          [placeholder]="placeholder" />
      </div>
    </div>
  `,
})
export class InputB3Decimal implements ControlValueAccessor {
  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: any;

  touched = false;

  private errorMessages = new Map<string, () => string>();
  mainClass = 'form-b3 form-field-b3';

  @Input()
  extraClass = '';
  @Input()
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';

  // Don't change fInputType default value!
  @Input()
  fInputType: 'number' | 'text' = 'text';
  @Input()
  fAutoComplete = 'off';
  @Input()
  fSuffixText = '';

  @Input()
  fMinVal: string;
  @Input()
  fMaxVal: string;
  @Input()
  placeholder = '';
  showPassword = false;
  @Output() informChangeEvent: EventEmitter<any> = new EventEmitter<any>();
  informChange(event) {
    this.informChangeEvent.emit(event);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  handleChange(event: any) {
    this.onTouched();

    const allowedCodes = [
      'Digit0',
      'Digit1',
      'Digit2',
      'Digit3',
      'Digit4',
      'Digit5',
      'Digit6',
      'Digit7',
      'Digit8',
      'Digit9',
      'Numpad0',
      'Numpad1',
      'Numpad2',
      'Numpad3',
      'Numpad4',
      'Numpad5',
      'Numpad6',
      'Numpad7',
      'Numpad8',
      'Numpad9',

      'Period',
      'Backspace',
      'Delete',
      'ArrowLeft',
      'ArrowRight',
    ];

    const allowedKeys = ['.'];

    let keyboardCode = event.code;

    // Handle unidentified key event on mobile
    if (event.key === 'Unidentified') {
      const inputValue = event.target.value;
      const lastLetter = inputValue.charAt(inputValue.length - 1);

      // Check if the last letter is a digit (0-9) or a period (.)
      if (lastLetter.match(/[0-9.]/)) {
        // If it's a period, handle separately
        if (lastLetter === '.') {
          keyboardCode = 'Period';
        } else {
          // Prepend "Digit" and set it as the event code
          keyboardCode = 'Digit' + lastLetter;
        }
      }
      if (inputValue === '') {
        keyboardCode = 'Backspace';
      }
    }

    if (event && keyboardCode && (allowedCodes.includes(keyboardCode) || allowedKeys.includes(event.key))) {
      const newVal = event.target.value
        .split('.')
        .map((item, index) => (index === 1 ? `.${item.slice(0, 2)}` : item))
        .join('');
      const fMin = parseInt(this.fMinVal);
      const fMax = parseInt(this.fMaxVal);
      const changeVal = parseInt(event.target.value);

      this.onChanged(newVal);
      if (fMin || fMax) {
        if (fMin && fMin >= changeVal) {
          this.formValue = fMin;
        }

        if (fMax && fMax < changeVal) {
          this.formValue = fMax;
        }
      }
      this.formValue = newVal;
      this.onChanged(newVal);
    } else {
      if (parseInt(event.target.value)) {
        this.formValue = parseInt(event.target.value.slice(0, -1));
      } else {
        this.formValue = parseInt('0');
      }
      // this.onChanged(event.target.value);
    }

    this.informChange(event);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }

  toogleShowPassword(): void {
    this.showPassword = !this.showPassword;
  }
}

@Component({
  selector: 'dropdownb3',
  template: `
    <div class="form-b3 form-field-b3" (click)="onTouched()">
      <label class="label-b3" *ngIf="fPlaceholder !== ''">{{ fPlaceholder }}:</label>
      <div class="dropdown">
        <button
          #dropdownMain
          type="button"
          tabindex="0"
          [class]="'dropdown-toggle buttonD ' + (formValue !== '' ? 'selected' : 'not-selected')"
          aria-expanded="false"
          (click)="toogleMenuOpen()">
          <span> {{ showValue() }} </span>
        </button>
        <div
          outsideListener
          (clickOutside)="handleOutside($event)"
          aria-labelledby="langIdDropdown"
          aria-haspopup="true"
          [ngClass]="{ 'dropdown-menu': true, show: isMenuOpen }"
          x-placement="bottom-left"
          style="position: absolute; top: 0px; left: 0px; will-change: transform; transform: translate(0px, 33px);">
          <button *ngFor="let x of fData" type="button" [class]="'dropdown-item py-2' + ' ' + fextraClass" (click)="writeValue(x[fDataValueKey])">
            {{ x[fDataViewKey] }}
          </button>
        </div>
        <div class="error-b3" *ngIf="showError">
          {{ fErrorText }}
        </div>
      </div>
    </div>
  `,
})
export class Dropdownb3 implements ControlValueAccessor {
  @ViewChild('dropdownMain', { static: true })
  dropdownMain: ElementRef<HTMLInputElement>;
  @Output() Select = new EventEmitter<any>();
  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: string;

  touched = false;

  isMenuOpen = false;

  private errorMessages = new Map<string, () => string>();
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType = 'text';
  @Input()
  fAutoComplete = 'off';
  @Input()
  fData = [];
  @Input()
  fDataValueKey = '';
  @Input()
  fDataViewKey = '';
  @Input()
  fDefaultSelectText = 'Pick one';
  @Input()
  fextraClass = '';

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  handleChange(change: any) {
    this.onTouched();
    this.onChanged(change);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
    this.Select.emit(this.formValue);
  }

  toogleMenuOpen(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  handleOutside($event): void {
    if (!this.dropdownMain.nativeElement.contains($event.targetElement)) {
      this.isMenuOpen = false;
    }
  }
  showValue(): any {
    if (!Array.isArray(this.fData)) {
      // fData bir dizi değilse, varsayılan metni döndür veya bir hata mesajı göster
      return this.fDefaultSelectText;
    }

    const filteredData = this.fData.filter(x => x[this.fDataValueKey] == this.formValue);

    return filteredData.length > 0 ? filteredData[0][this.fDataViewKey] : this.fDefaultSelectText;
  }
}

@Component({
  selector: 'dropdownb3icon',
  template: `
    <div class="form-b3 form-field-b3" (click)="onTouched()">
      <label class="label-b3" *ngIf="fPlaceholder !== ''">{{ fPlaceholder }}:</label>
      <div class="dropdown dropdown-w-icon">
        <button
          #dropdownMain
          type="button"
          tabindex="0"
          [class]="'dropdown-toggle buttonD ' + (formValue !== '' ? 'selected' : 'not-selected')"
          aria-expanded="false"
          (click)="toogleMenuOpen()">
          <image-loader-flag-utils [isFlags]="true" [url]="getIconKey(showValue())" extraClasses="dropdown-icon"></image-loader-flag-utils>
          <span> {{ showValue().name }} </span>
        </button>
        <div
          outsideListener
          (clickOutside)="handleOutside($event)"
          aria-labelledby="langIdDropdown"
          aria-haspopup="true"
          [ngClass]="{ 'dropdown-menu': true, show: isMenuOpen }"
          x-placement="bottom-left">
          <button *ngFor="let x of fData" type="button" [class]="'dropdown-item dropdown-item-w-icon py-2' + ' ' + fextraClass" (click)="writeValue(x[fDataValueKey])">
            <image-loader-flag-utils [isFlags]="true" [url]="getIconKey(x)" extraClasses="dropdown-icon"></image-loader-flag-utils>
            {{ x[fDataViewKey] }}
          </button>
        </div>
        <div class="error-b3" *ngIf="showError">
          {{ fErrorText }}
        </div>
      </div>
    </div>
  `,
})
export class Dropdownb3icon implements ControlValueAccessor {
  @ViewChild('dropdownMain', { static: true })
  dropdownMain: ElementRef<HTMLInputElement>;
  @Input()
  iconKey = 'iconvalue';
  @Output() Select = new EventEmitter<any>();
  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }
  getIconKey(x) {
    try {
      return x[this.iconKey].toLowerCase();
    } catch (error) {
      return '';
    }
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: string;

  touched = false;

  isMenuOpen = false;

  private errorMessages = new Map<string, () => string>();
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType = 'text';
  @Input()
  fAutoComplete = 'off';
  @Input()
  fData = [];
  @Input()
  fDataValueKey = '';
  @Input()
  fDataViewKey = '';
  @Input()
  fDefaultSelectText = 'Pick one';
  @Input()
  fextraClass = '';

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  handleChange(change: any) {
    this.onTouched();
    this.onChanged(change);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
    this.Select.emit(this.formValue);
  }

  toogleMenuOpen(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  handleOutside($event): void {
    if (!this.dropdownMain.nativeElement.contains($event.targetElement)) {
      this.isMenuOpen = false;
    }
  }
  showValue(): any {
    if (!Array.isArray(this.fData)) {
      // fData bir dizi değilse, varsayılan metni döndür veya bir hata mesajı göster
      return this.fDefaultSelectText;
    }

    const filteredData = this.fData.filter(x => x[this.fDataValueKey] == this.formValue);

    if (filteredData.length > 0) {
      // Hem ülke ismini hem de ISO2 kodunu döndür
      return { name: filteredData[0][this.fDataViewKey], [this.iconKey]: filteredData[0]['ISO2'] };
    } else {
      return { name: this.fDefaultSelectText, [this.iconKey]: null };
    }
  }
}

@Component({
  selector: 'datepickerb3',
  template: `
    <div class="form-b3 form-field-b3 datepickerb3">
      <label class="label-b3">{{ fPlaceholder }}:</label>
      <div class="dropdown-container">
        <!-- Gün Dropdown -->
        <dropdownb3 [fDefaultSelectText]="'Day' | translate" [fData]="daysArr" [fDataValueKey]="'value'" [fDataViewKey]="'name'" (Select)="setDay($event)"></dropdownb3>
        <!-- Ay Dropdown -->
        <dropdownb3 [fDefaultSelectText]="'Month' | translate" [fData]="monthsArr" [fDataValueKey]="'value'" [fDataViewKey]="'name'" (Select)="setMonth($event)"></dropdownb3>
        <!-- Yıl Dropdown -->
        <dropdownb3 [fDefaultSelectText]="'Year' | translate" [fData]="yearsArr" [fDataValueKey]="'value'" [fDataViewKey]="'name'" (Select)="setYear($event)"></dropdownb3>
      </div>
      <div class="error-b3" *ngIf="!isValid || !isEighteenOrOlder">
        {{ fErrorText }}
      </div>
    </div>
  `,
})
export class DatePickerB3 implements ControlValueAccessor {
  // ...

  // Seçilen değerleri saklayacak değişkenler
  date;
  selectedDay: number;
  selectedMonth: number;
  selectedYear: number;
  isValid = true;
  isEighteenOrOlder = true;
  monthsArr = [
    { name: this._TranslateService.instant('January'), value: 1 },
    { name: this._TranslateService.instant('February'), value: 2 },
    { name: this._TranslateService.instant('March'), value: 3 },
    { name: this._TranslateService.instant('April'), value: 4 },
    { name: this._TranslateService.instant('May'), value: 5 },
    { name: this._TranslateService.instant('June'), value: 6 },
    { name: this._TranslateService.instant('July'), value: 7 },
    { name: this._TranslateService.instant('August'), value: 8 },
    { name: this._TranslateService.instant('September'), value: 9 },
    { name: this._TranslateService.instant('October'), value: 10 },
    { name: this._TranslateService.instant('November'), value: 11 },
    { name: this._TranslateService.instant('December'), value: 12 },
  ];
  yearsArr = this.getYearsArray();
  daysArr = this.generateParametricItems(31, 1);
  formValue: string;

  constructor(@Self() @Optional() public control: NgControl, public _LocalizationService: LocalizationService, private _TranslateService: TranslateService) {
    this.control && (this.control.valueAccessor = this);
  }

  getYearsArray() {
    // Son 100 yıl için yıl seçenekleri oluştur
    const currentYear = subYears(new Date(), 18).getFullYear();
    const yearsArray = Array.from({ length: 80 }, (_, i) => currentYear - i);
    const yearObjectsArray = yearsArray.map(year => ({
      name: String(year),
      value: year,
    }));

    return yearObjectsArray;
  }
  generateParametricItems(length: number, start = 1): Array<{ name: string; value: number }> {
    const items: Array<{ name: string; value: number }> = [];

    for (let i = 0; i < length; i++) {
      const index = i + start;
      items.push({ name: String(index), value: Number(index) });
    }

    return items;
  }
  // Dropdown seçimleri için metotlar
  setDay(day: number) {
    this.selectedDay = day;
    this.combineDate();
  }
  setMonth(month: number) {
    this.selectedMonth = month;
    this.combineDate();
  }
  setYear(year: number) {
    this.selectedYear = year;
    this.combineDate();
  }

  // Tarih oluşturma metodu
  combineDate() {
    if (this.selectedDay && this.selectedMonth && this.selectedYear) {
      this.checkValidDate(this.selectedDay, this.selectedMonth, this.selectedYear);
    }
  }
  checkValidDate(day: number, month: number, year: number) {
    // Ayı düzeltmek için 1 çıkarılır (Ocak ayı 0'dır)
    const adjustedMonth = month - 1;

    // Girilen değerlerle bir tarih oluştur
    const dateString = `${year}-${month}-${day}`;
    this.date = parse(dateString, 'yyyy-M-d', new Date());
    this.isValid = isValid(this.date) && this.date.getDate() === day && this.date.getMonth() === adjustedMonth && this.date.getFullYear() === year;
    // 18 yaş kontrolü
    const today = new Date();
    const eighteenYearsAgo = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    //18 yaşından büyük olup olmadığını kontrol et
    this.isEighteenOrOlder =
      this.date < eighteenYearsAgo ||
      (this.date.getFullYear() === eighteenYearsAgo.getFullYear() && this.date.getMonth() === eighteenYearsAgo.getMonth() && this.date.getDate() <= eighteenYearsAgo.getDate());
    this.setFormValue();
  }
  setFormValue() {
    if (this.isValid && this.isEighteenOrOlder) {
      this.formValue = format(this.date, 'yyyy-MM-dd');
    } else {
      this.formValue = '';
    }
    this.onTouched();
    this.onChanged(this.formValue);
  }

  private errorMessages = new Map<string, () => string>();
  @Input()
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType = 'text';
  @Input()
  fAutoComplete = 'off';
  @Input()
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  handleChange(change: any) {
    this.onTouched();
    this.onChanged(change);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }
}

@Component({
  selector: 'textareab3',
  template: `
    <div [class]="mainClass + ' ' + extraClass + ' ' + fInputType">
      <label [for]="fID" class="label-b3">{{ fPlaceholder }}</label>

      <div [class]="'input-container ' + fInputType">
        <textarea
          [class]="'formType_' + fInputType"
          [rows]="fTextRows"
          [cols]="fTextCols"
          [id]="fID"
          [name]="fID"
          [required]="isRequired"
          [(ngModel)]="formValue"
          (ngModelChange)="handleChange($event)"
          (click)="onTouched()"
          [disabled]="disabled"></textarea>
      </div>
      <div class="error-b3" *ngIf="showError">
        {{ fErrorText }}
      </div>
    </div>
  `,
})
export class Textareab3 implements ControlValueAccessor {
  constructor(@Self() @Optional() public control: NgControl) {
    this.control && (this.control.valueAccessor = this);
  }

  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  formValue: any;

  private errorMessages = new Map<string, () => string>();
  mainClass = 'form-b3 form-field-b3';

  @Input()
  extraClass = '';
  @Input()
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  fID = 'null';
  @Input()
  fHint = '';
  @Input()
  fErrorText = '';
  @Input()
  fPlaceholder = '';
  @Input()
  fInputType: 'text' | 'password' | 'number' = 'text';
  @Input()
  fSuffixText = '';
  @Input()
  fTextRows: string;
  @Input()
  fTextCols: string;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  handleChange(change: any) {
    this.onTouched();
    this.onChanged(change);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }
}
